import { FaEye, FaHeartbeat, FaGlasses, FaMicroscope, FaPills, FaDna, FaBacteria, FaChartBar, FaXRay, FaStethoscope, FaUserInjured, FaBaby, FaBrain, FaFlask } from "react-icons/fa";

export const topicIcons: { [key: string]: JSX.Element } = {
  // FRCOphth topics
  "Anatomy": <FaEye />,
  "Physiology": <FaHeartbeat />,
  "Optics": <FaGlasses />,
  "Instruments, Lasers, & Optics": <FaGlasses />,
  "Pathology": <FaMicroscope />,
  "Pharmacology": <FaPills />,
  "Genetics": <FaDna />,
  "Clinical Genetics": <FaDna />,
  "Biochemistry and Biostatistics": <FaChartBar />,
  "Microbiology & Immunology": <FaBacteria />,
  "Statistics & Evidence-Based Medicine": <FaChartBar />,
  "Investigations & Imaging": <FaXRay />,
  "Cornea & External Disease": <FaEye />,
  "Cataract & Refractive Surgery": <FaGlasses />,
  "Glaucoma": <FaEye />,
  "Retina": <FaEye />,
  "Uveitis": <FaEye />,
  "Neurology & Pupils": <FaBrain />,
  "Paediatric Ophthalmology & Strabismus": <FaBaby />,
  "Oculoplastics": <FaUserInjured />,
  "Ocular Oncology": <FaFlask />,
  "Trauma": <FaUserInjured />,
  "Neuro-imaging & Investigations": <FaXRay />,

  // MSRA topic groups (reusing existing, known-good icons)
  "Allergy, Immunology & Infection": <FaBacteria />,
  "Cardiovascular": <FaHeartbeat />,
  "Dermatology": <FaMicroscope />,
  "Endocrinology & Metabolic": <FaPills />,
  "ENT & Respiratory": <FaStethoscope />,
  "Ophthalmology & Eyes": <FaEye />,
  "Gastroenterology & General Medicine": <FaMicroscope />,
  "Haematology & Oncology": <FaFlask />,
  "Musculoskeletal & Trauma": <FaUserInjured />,
  "Neurology": <FaBrain />,
  "Obstetrics & Gynaecology": <FaBaby />,
  "Paediatrics": <FaBaby />,
  "Pharmacology & Therapeutics": <FaPills />,
  "Psychiatry": <FaBrain />,
  "Renal & Urology": <FaFlask />
};

